import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'; // Adjust based on your context structure

const AuthRoute = () => {
  const { isAuthenticated } = useAuth(); // Assume this returns the logged-in user or null

  return !isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default AuthRoute;